import * as fromDatatype from "../datatype-library/index";

export interface bl_inv_stock_replenishment_run_supplier_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  hdr_guid: fromDatatype.GuidDataFieldInterface;
  supplier_guid: fromDatatype.GuidDataFieldInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
}

export class bl_inv_stock_replenishment_run_supplier_RowClass
  implements bl_inv_stock_replenishment_run_supplier_RowInterface
{
  guid: fromDatatype.GuidDataFieldInterface;
  hdr_guid: fromDatatype.GuidDataFieldInterface;
  supplier_guid: fromDatatype.GuidDataFieldInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
}
